import React from "react";
import { Button, Divider } from "@material-ui/core";
import ScheduledCallIcon from "./Icons/ScheduledCallIcon";
import MissedCallIcon from "./Icons/MissedCallsIcon";
import QueueCallIcon from "./Icons/QueueCallIcon";
import { useTheme } from "@material-ui/core/styles";
import classnames from "classnames";
import tinycolor from "tinycolor2";

// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers/Wrapper";

const typesIcons = {
	msg: <ScheduledCallIcon />,
	notification: <MissedCallIcon />,
	info: <QueueCallIcon />,
};

export default function Notification({ variant, ...props }) {
	var classes = useStyles();
	var theme = useTheme();

	const icon = getIconByType(props.type);
	const iconWithStyles = React.cloneElement(icon, {
		classes: {
			root: classes.notificationIcon,
		},
		style: {
			color: variant !== "contained" && theme.palette[props.color] && theme.palette[props.color].main,
		},
	});
	return (
		<div
			className={classnames(classes.notificationContainer, props.className, {
				[classes.notificationContained]: variant === "contained",
				[classes.notificationContainedShadowless]: props.shadowless,
			})}
			style={{
				backgroundColor: variant === "contained" && theme.palette[props.color] && theme.palette[props.color].main,
			}}>
			<div
				className={classnames(classes.notificationIconContainer, {
					[classes.notificationIconContainerContained]: variant === "contained",
					[classes.notificationIconContainerRounded]: variant === "rounded",
				})}
				style={{
					backgroundColor:
						variant === "rounded" &&
						theme.palette[props.color] &&
						tinycolor(theme.palette[props.color].main)
							.setAlpha(0.15)
							.toRgbString(),
				}}>
				{iconWithStyles}
			</div>
			<div className={classes.messageContainer}>
				<div style={{ display: "inline-grid" }}>
					<Typography
						className={classnames({
							[classes.containedTypography]: variant === "contained",
						})}
						variant={props.typographyVariant}
						size={variant !== "contained" && !props.typographyVariant && "md"}>
						{props.message}
					</Typography>
					{/* </div>
        <div> */}
					<Typography
						style={{ fontSize: "12px", color: "darkgray" }}
						className={classnames({
							[classes.containedTypographyValue]: variant === "contained",
						})}
						variant={props.typographyVariant}
						size={variant !== "contained" && !props.typographyVariant && "md"}>
						{props.Date}
					</Typography>
				</div>
				{props.extraButton && props.extraButtonClick && (
					<Button onClick={props.extraButtonClick} disableRipple className={classes.extraButton}>
						{props.extraButton}
					</Button>
				)}
			</div>
			<Divider />
		</div>
	);
}

// ####################################################################
function getIconByType(type = "msg") {
	return typesIcons[type];
}
